import {
  FunctionPayload,
  ADD_FUNCTIONS,
} from "./types";

const initialState: any = {
  functionData: [],
}

export function marketPlaceFunctionReducer(
  state = initialState,
  action: FunctionPayload
) {
  switch (action.type) {
    case ADD_FUNCTIONS:
      if (Array.isArray(action.data)) {
        return {
          ...state,
          functionData: action.data
        }
      }
      return {
        ...state,
        functionData: [action.data, ...state.functionData]
      }
    default:
      return state
  }
}
